module.exports = __webpack_public_path__ + "img/page_1_3.0fff73ae.png";